
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-pejabat-penilai-kinerja/penilai/perencanaan/daftar-ps/setujui-sekaligus/konfirmasi",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-pejabat-penilai-kinerja/penilai/perencanaan/daftar-ps/setujui-sekaligus/konfirmasi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-pejabat-penilai-kinerja/penilai/perencanaan/daftar-ps/setujui-sekaligus/konfirmasi"])
      });
    }
  